import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React, { useCallback, useState } from "react";
import { useStepUpChallenge } from "@catchoftheday/auth";
import { Box, Button, Form } from "@catchoftheday/cg-components";
import { getEnvConfig } from "@catchoftheday/env-config";
import { initClient } from "@catchoftheday/graphql-utils";
import { minusOnePx, useMedia, useTheme } from "@catchoftheday/theme";
import { triggerToast } from "@catchoftheday/toast";
import { getFormValidationSchema, getSalesChannel } from "@catchoftheday/utilities";
import { COPY_PERSONAL_DETAILS_UPDATE_FAILURE, COPY_PERSONAL_DETAILS_UPDATE_SUCCESS } from "../../../consts/index.js";
import { useUpdatePersonalDetailsMutation } from "../../../generated/graphql.jsx";
import { RequiredInput } from "../../pure/personal-details/RequiredInput/RequiredInput.jsx";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var PersonalDetailsFormContainer = function PersonalDetailsFormContainer(_ref) {
  var host = _ref.host,
      customer = _ref.customer;
  var theme = useTheme();
  var isMobile = useMedia(["(max-width: ".concat(minusOnePx(theme.breakpoints.md), ")")], [true]);
  var isCotd = !!host && getSalesChannel(host) === "COTD";

  var _useState = useState(customer),
      formData = _useState[0],
      setFormData = _useState[1];

  var _useStepUpChallenge = useStepUpChallenge({
    onStepUpChallengeSuccess: function () {
      var _onStepUpChallengeSuccess = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(formInput) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (formInput) {
                  updatePersonalDetails({
                    variables: {
                      input: formInput
                    }
                  });
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function onStepUpChallengeSuccess(_x) {
        return _onStepUpChallengeSuccess.apply(this, arguments);
      }

      return onStepUpChallengeSuccess;
    }(),
    onStepUpChallengeError: function () {
      var _onStepUpChallengeError = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                triggerToast({
                  isError: true,
                  message: COPY_PERSONAL_DETAILS_UPDATE_FAILURE
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function onStepUpChallengeError() {
        return _onStepUpChallengeError.apply(this, arguments);
      }

      return onStepUpChallengeError;
    }()
  }),
      getPathWithProxy = _useStepUpChallenge.getPathWithProxy,
      triggerStepUpChallenge = _useStepUpChallenge.triggerStepUpChallenge;

  var _useUpdatePersonalDet = useUpdatePersonalDetailsMutation({
    client: initClient({
      initialState: {},
      uri: getPathWithProxy(getEnvConfig().GRAPHQL_ENDPOINT)
    }),
    onCompleted: function onCompleted(data) {
      var _data$updatePersonalD;

      if (((_data$updatePersonalD = data.updatePersonalDetails) === null || _data$updatePersonalD === void 0 ? void 0 : _data$updatePersonalD.__typename) === "UpdatePersonalDetailsSuccessResponse") {
        var _ref2 = data.updatePersonalDetails || {},
            customerData = _ref2.data,
            message = _ref2.message;

        setFormData({
          email: customerData === null || customerData === void 0 ? void 0 : customerData.email,
          phone: customerData === null || customerData === void 0 ? void 0 : customerData.phone,
          firstName: customerData === null || customerData === void 0 ? void 0 : customerData.firstName,
          lastName: customerData === null || customerData === void 0 ? void 0 : customerData.lastName
        });
        triggerToast({
          isError: false,
          message: message || COPY_PERSONAL_DETAILS_UPDATE_SUCCESS
        });
      } else {
        triggerToast({
          isError: true,
          message: data.updatePersonalDetails.error.message
        });
      }
    },
    onError: function onError() {
      triggerToast({
        isError: true,
        message: COPY_PERSONAL_DETAILS_UPDATE_FAILURE
      });
    }
  }),
      _useUpdatePersonalDet2 = _slicedToArray(_useUpdatePersonalDet, 2),
      updatePersonalDetails = _useUpdatePersonalDet2[0],
      isLoading = _useUpdatePersonalDet2[1].loading;

  var changeFormData = function changeFormData(fieldName, value) {
    setFormData(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, fieldName, value));
    });
  };

  var submitForm = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!formData) {
              _context3.next = 3;
              break;
            }

            _context3.next = 3;
            return triggerStepUpChallenge(formData);

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })), [formData, triggerStepUpChallenge]);
  return ___EmotionJSX(Form, {
    onSubmit: submitForm,
    schema: getFormValidationSchema({
      isMobile: isMobile || false,
      isCotd: isCotd
    })
  }, ___EmotionJSX(Box, {
    display: "grid",
    rowGap: 5,
    columnGap: 5,
    gridTemplateColumns: {
      xs: "repeat(1, 1fr)",
      md: "repeat(2, 1fr)"
    }
  }, ___EmotionJSX(RequiredInput, {
    id: "email",
    name: "email",
    label: "Email",
    defaultValue: formData.email || "",
    onChange: function onChange(event) {
      return changeFormData("email", event.target.value);
    }
  }), ___EmotionJSX(RequiredInput, {
    id: "phone",
    name: "phone",
    label: "Phone",
    placeholder: "Your mobile / landline number",
    defaultValue: formData.phone || "",
    onChange: function onChange(event) {
      return changeFormData("phone", event.target.value);
    }
  }), ___EmotionJSX(RequiredInput, {
    id: "firstName",
    name: "firstName",
    label: "First name",
    placeholder: "Your first name",
    defaultValue: formData.firstName || "",
    onChange: function onChange(event) {
      return changeFormData("firstName", event.target.value);
    }
  }), ___EmotionJSX(RequiredInput, {
    id: "lastName",
    name: "lastName",
    label: "Last name",
    placeholder: "Your last name",
    defaultValue: formData.lastName || "",
    onChange: function onChange(event) {
      return changeFormData("lastName", event.target.value);
    }
  })), ___EmotionJSX(Button, {
    type: "submit",
    maxWidth: 125,
    display: "block",
    mt: 6,
    disabled: isLoading
  }, "Save"));
};